<template>
  <div>
    <!-- 侧边按钮 -->
    <div class="side-menu">
      <div class="side-menu-item" @click="$router.push({path:'/event/enter'})">
        <a-icon type="carry-out" />
        <span>我要报名</span>
      </div>
      <div class="side-menu-item" @click="$router.push({path: '/user/myPaper'})">
        <a-icon type="calculator" />
        <span>模拟练习</span>
      </div>
      <div class="side-menu-item" @click="$router.push({path: '/cms/list', query:{type:8}})">
        <a-icon type="question-circle" />
        <span>获取帮助</span>
      </div>
      <div class="side-menu-item" @click="open53">
        <a-icon type="customer-service" />
        <span>在线咨询</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSideMenu",
  created(){

  },
  mounted(){
    setInterval(function(){
      let kfdom = document.getElementById("icon_module")
      if(kfdom){ kfdom.style.display = "none"}
      kfdom = document.getElementById("mobile_icon_div")
      if(kfdom){ kfdom.style.display = "none"}
    }, 1000)
  },
  methods:{
    open53(){
      window.open_floatWindow()
    }
  }
};
</script>

<style lang="less" scoped>
.side-menu {
  width: 60px;
  position: fixed;
  right: 0;
  z-index: 999;
  .side-menu-item {
    display: block;
    cursor: pointer;
    width: 60px;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #fff;
    // border-bottom: 1px solid #eee;
    background: #4682fc;
    padding: 10px;
    .anticon{
        display: block;
        font-size: 36px;
        margin-bottom: 4px;
    }
  }
  .side-menu-item:hover {
    background: #2962d6;
  }
}
</style>